import LettersMenu from './lettersMenu.class';
export default class AlphabeticalOrderModule {
  init() {
    const letterMenuInstance = new LettersMenu();
    letterMenuInstance.init();
  }
}